import React, { Component } from 'react';
import axios from 'axios';

import Loader from './nav/Loader';

const baseResultsURL = "https://www.roadtonationals.com/api/men/coachespoll2";

class CoachesPoll extends Component {
  constructor(props) {
      super(props);
      this.state = {
        data: [],
        ncaa: [],
        gymact: [],
        showLoader: true
      };
      this.getNCAAChart = this.getNCAAChart.bind(this);
      this.getGymACTChart = this.getGymACTChart.bind(this);
  }
  componentWillMount() {
    this.getResults({});
  }
  getResults(config) {
    var url = baseResultsURL + '/';
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
        let num = 1;
        let prevpoints = 0;
        response.data.ncaa.forEach(function(key, index){
          if(Number(key.points) === prevpoints) {
            response.data.ncaa[index].rank = num;
          } else {
            response.data.ncaa[index].rank = index+1;
            num = index+1;
          }
          prevpoints = Number(key.points);
        });

        num = 1;
        prevpoints = 0;
        response.data.gymact.forEach(function(key, index){
          if(Number(key.points) === prevpoints) {
            response.data.gymact[index].rank = num;
          } else {
            response.data.gymact[index].rank = index+1;
            num = index+1;
          }
          prevpoints = Number(key.points);
        });

        this.setState({
          data : response.data,
          ncaa : response.data.ncaa,
          gymact : response.data.gymact,
          showLoader: false
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  getFirsts(row) {
    if(Number(row.firsts) > 0) {
      return <span>({row.firsts} first place votes)</span>;
    } else {
      return ;
    }
  }
  getNCAAChart(){
    const rows = this.state.ncaa.map((row, index) =>
      <tr key={row.team_name}><td>{row.rank}</td><td>{row.team_name}</td><td>{row.points} {this.getFirsts(row)}</td></tr>
    );
    return <div><table><tbody><tr><th>Rank</th><th>Team</th><th>Points</th></tr>{rows}</tbody></table></div>;
  }
  getGymACTChart(){
    const rows = this.state.gymact.map((row, index) =>
      <tr key={row.team_name}><td>{row.rank}</td><td>{row.team_name}</td><td>{row.points} {this.getFirsts(row)}</td></tr>
    );
    return <div><table><tbody><tr><th>Rank</th><th>Team</th><th>Points</th></tr>{rows}</tbody></table></div>;
  }
  render() {
    if(this.state.showLoader === false){
      return (
        <div className="mainContainer">
          <div className="row">
            <div className="small-12 columns">
              <p className="schedule-header-txt">{this.state.ncaa[0].name} ({this.state.ncaa[0].date})</p>
              {this.getNCAAChart()}
            </div>
          </div>
        </div>
      );
    } else {
      return <Loader />;
    }
  }
}

export default CoachesPoll;

/*
<div className="row">
  <div className="small-12 columns">
    <p className="schedule-header-txt">{this.state.gymact[0].name} ({this.state.gymact[0].date})</p>
    {this.getGymACTChart()}
  </div>
</div>
*/



// WEBPACK FOOTER //
// ./src/components/CoachesPoll.js